import { FC } from 'react';
import { ListPost } from 'types/PostDetail';
import HorizontalPostCard from 'app/modules/posts/components/HorizontalPostCard';
import clsx from 'clsx';
import { Alert, AlertProps, Checkbox } from '@kontentino/ui';

type Props = {
  posts: ListPost[];
  selectedPosts: ListPost[];
  disabledPosts?: number[];
  warningMessages?: Record<string, string>;
  warningMessagesVariant?: AlertProps['variant'];
  onSelectPost: (post: ListPost) => void;
  className?: string;
};

const List: FC<Props> = ({
  posts,
  selectedPosts,
  disabledPosts,
  warningMessages,
  warningMessagesVariant = 'warning',
  onSelectPost,
  className,
}) => {
  return (
    <div
      className={clsx(
        'tw-flex tw-h-[430px] tw-flex-col tw-gap-4 tw-overflow-auto tw-p-4',
        className,
      )}
      translate="no"
    >
      {posts.map((post) => (
        <div
          className="tw-relative tw-border-b tw-border-grayscale-10 tw-pb-1"
          key={`post-${post.id}`}
        >
          <div className="tw-absolute tw-left-2 tw-top-2 tw-z-10">
            <Checkbox
              size="small"
              onClick={() => onSelectPost(post)}
              onChange={() => {}}
              checked={selectedPosts
                .map((selectedPost) => selectedPost.id)
                .includes(post.id)}
              disabled={disabledPosts?.includes(post.id)}
            />
          </div>
          <HorizontalPostCard
            post={post}
            withPageInfo
            onClick={() => onSelectPost(post)}
            className={clsx('tw-rounded tw-border-none tw-pl-9', {
              'tw-pointer-events-none tw-opacity-50': disabledPosts?.includes(
                post.id,
              ),
              '!tw-bg-grayscale-5': selectedPosts
                .map((selectedPost) => selectedPost.id)
                .includes(post.id),
            })}
            afterContent={
              warningMessages?.[post.id] && (
                <div className="tw-w-full">
                  <Alert variant={warningMessagesVariant}>
                    {warningMessages?.[post.id]}
                  </Alert>
                </div>
              )
            }
          />
        </div>
      ))}
    </div>
  );
};

export default List;
